import { useReducer } from 'react'

export const useForceRender = () => {
  // Função para forçar o re-render no componente e poder disparar programaticamente,
  // evitando assim, um duplo re-render se fosse utilizado `state` em alguns casos.
  // Baseado em: https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
  return useReducer((x) => x + 1, 0)[1]
}
